import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
const notThis = ['This is NOT a random collection of hybrid sessions copied from online.', 'This is NOT a theoretical manual you need to rewrite before it works in a real training session.', 'This is NOT content designed for a different type of coach that you need to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-charcoal text-white relative" data-id="element-254" data-mp="z1mpu41vpzns">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-orange" data-id="element-255" data-mp="u3bgdufhxr63" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-256" data-mp="18342tdjzpl89">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-257" data-mp="140h7v3s0vk6u">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/5 border border-orange/50 text-orange mb-5" data-id="element-258" data-mp="2fge6xktkrkhs">
            <TrophyIcon size={26} aria-hidden="true" data-id="element-259" data-mp="2bxtf4zvuhdzw" />
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold uppercase mb-4" data-id="element-260" data-mp="2gth4pge8o95x">
            The most complete hybrid fitness racing coaching library for coaches
            worldwide
          </h2>
          <h3 className="text-xl font-bold uppercase text-orange mb-3" data-id="element-261" data-mp="2pu6zcgrrjti2">
            Hybrid Race Coach Ready — a complete 6-in-1 coaching system
          </h3>
          <p className="text-base md:text-lg text-white/70 mb-10" data-id="element-262" data-mp="1x6jed0mkz0uw">
            120 ready-to-coach sessions · 5 premium bonuses · Everything ready
            to use today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left items-stretch" data-id="element-263" data-mp="26x5qgkv3998u">
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-graphite p-6 rounded-2xl border border-white/10" data-id="element-264" data-mp="19h8c1epl0yen">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-265" data-mp="2crvwxp6fur46">
                <XIcon className="text-warmgray shrink-0 mt-0.5" size={18} aria-hidden="true" data-id="element-266" data-mp="2qihhdibjj946" />
                <p className="text-white/70 text-sm" data-id="element-267" data-mp="1yscy5mzios4j">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white p-6 rounded-2xl border-2 border-orange shadow-lg flex items-center" data-id="element-268" data-mp="1tttbtlh0hebn">
            <div className="flex items-start gap-3" data-id="element-269" data-mp="3j6ddaktacwzw">
              <CheckIcon className="text-orange shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-270" data-mp="3e9n0c6cs2hip" />
              <p className="text-charcoal font-medium text-base leading-relaxed" data-id="element-271" data-mp="3ms8fst1l3004">
                This is a complete professional 6-in-1 coaching system — so you
                walk into every session completely prepared, confident and ready
                to deliver a workout your athletes will truly feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}